<app-modal-shell [showFooter]="true"
  [dismissLabel]="'general.close' | translate"
  (dismiss)="dismiss()">
  <div modalTitle>
    <h2>
      @if (item()) {
        {{ item().name }}
      } @else {
        {{ 'room.addingAreas' | translate }}
      }
    </h2>
  </div>

  <section class="area-modal">
    @if (item()) {
      <div class="area-modal__context">
        @if (item().size) {
          <div>{{ 'room.size' | translate }} {{ item().size }} m<sup>2</sup></div>
        }
        @if (item().volume) {
          <div>{{ 'room.volume' | translate }} {{ item().volume }} m<sup>3</sup></div>
        }
        @if (item().height) {
          <div>{{ 'room.height' | translate }} {{ item().height }} m</div>
        }
      </div>
    }

    @if (type() == null) {
      @if (rooms == null) {
        <div class="area-modal__actions">
          <button class="area-modal__button area-modal__button--secondary"
            type="button"
            (click)="selectAddArea()">
            <ion-icon name="add-outline"></ion-icon>
            <span>{{ 'room.addArea' | translate }}</span>
          </button>
          @if (hasEdit()) {
            <button class="area-modal__button area-modal__button--secondary"
              type="button"
              (click)="onEdit()">
              {{ 'general.edit' | translate }}
            </button>
          }
          @if (isRoot()) {
            <button class="area-modal__button area-modal__button--danger"
              type="button"
              (click)="deleteSelf()">
              {{ 'general.delete' | translate }}
            </button>
          }
        </div>
      } @else {
        <form class="area-modal__form"
          [formGroup]="roomFormGroup"
          (ngSubmit)="saveRooms()">
          <div class="area-modal__actions">
            <button class="area-modal__button area-modal__button--secondary"
              type="button"
              (click)="type.set('common')">
              <ion-icon name="add-outline"></ion-icon>
              <span>{{ 'room.addCommon' | translate }}</span>
            </button>
            @if (hasEdit()) {
              <button class="area-modal__button area-modal__button--secondary"
                type="button"
                (click)="onEdit()">
                {{ 'general.edit' | translate }}
              </button>
            }
          </div>

          <div class="area-modal__hint">{{ 'room.addCommonInfo' | translate }}</div>

          <div formArrayName="rooms"
            class="area-modal__rows">
            @for (item of getRooms().controls; track item; let i = $index) {
              <div class="area-modal__row">
                <input class="area-modal__input"
                  autocapitalize="on"
                  [formControlName]="i" />
                <button class="area-modal__icon-button area-modal__icon-button--danger"
                  type="button"
                  (click)="onDeleteRoom(i)">
                  <ion-icon name="remove-circle-outline"></ion-icon>
                </button>
              </div>
            }
          </div>
        </form>
      }
    }

    @switch (type()) {
      @case ('area') {
        <div class="area-modal__form">
          @if (parentName) {
            <p class="area-modal__hint">
              {{ 'room.addingTo' | translate:{name: parentName} }}
            </p>
          } @else {
            <p class="area-modal__hint">
              {{ 'room.addingAreasInfo' | translate }}
            </p>
          }

          <form [formGroup]="formGroup"
            (ngSubmit)="save()"
            class="area-modal__form">
            @if (isRoot()) {
              <div class="area-modal__field">
                <label class="area-modal__label">{{ 'room.name' | translate }}</label>
                <input class="area-modal__input"
                  autocapitalize="on"
                  formControlName="name" />
              </div>
            }

            @if (multiple()) {
              <div class="area-modal__field">
                <label class="area-modal__label">{{ 'room.numbers' | translate }}</label>
                <input class="area-modal__input"
                  autocapitalize="on"
                  formControlName="numbers" />
              </div>
            } @else {
              <div formArrayName="areas"
                class="area-modal__rows">
                <label class="area-modal__label">{{ 'room.areaName' | translate }}</label>
                @for (item of getFields().controls; track item; let i = $index) {
                  <div class="area-modal__row">
                    <input class="area-modal__input"
                      autocapitalize="on"
                      [formControlName]="i"
                      [placeholder]="'room.example' | translate:{index: (i + 1)}" />
                    <button class="area-modal__icon-button area-modal__icon-button--danger"
                      type="button"
                      (click)="deleteItem(i)">
                      <ion-icon name="remove-circle-outline"></ion-icon>
                    </button>
                  </div>
                }
              </div>

              <button class="area-modal__button area-modal__button--secondary"
                type="button"
                (click)="addItem()">
                <ion-icon name="add-outline"></ion-icon>
                <span>{{ 'item.addRow' | translate }}</span>
              </button>
            }

            <label class="area-modal__toggle-row">
              <span class="area-modal__toggle-label">{{ 'room.bulkCreate.toggleLabel' | translate }}</span>
              <ion-toggle aria-label=""
                (ionChange)="toggleMultiple()"></ion-toggle>
            </label>
            <p class="area-modal__hint">
              {{ 'room.bulkCreate.helper' | translate }}
            </p>

            @if (multiple()) {
              <div class="area-modal__defaults">
                <h4 class="area-modal__defaults-title">{{ 'room.bulkCreate.defaultsTitle' | translate }}</h4>
                <p class="area-modal__hint">{{ 'room.bulkCreate.defaultsInfo' | translate }}</p>

                <div class="area-modal__field-grid">
                  <div class="area-modal__field">
                    <label class="area-modal__label">{{ 'room.size' | translate }}</label>
                    <input class="area-modal__input"
                      type="number"
                      formControlName="size" />
                  </div>
                  <div class="area-modal__field">
                    <label class="area-modal__label">{{ 'room.volume' | translate }}</label>
                    <input class="area-modal__input"
                      type="number"
                      formControlName="volume" />
                  </div>
                  <div class="area-modal__field">
                    <label class="area-modal__label">{{ 'room.height' | translate }}</label>
                    <input class="area-modal__input"
                      type="number"
                      formControlName="height" />
                  </div>
                  <div class="area-modal__field">
                    <label class="area-modal__label">{{ 'room.internal_doors' | translate }}</label>
                    <input class="area-modal__input"
                      type="number"
                      formControlName="internal_doors" />
                  </div>
                  <div class="area-modal__field">
                    <label class="area-modal__label">{{ 'room.external_doors' | translate }}</label>
                    <input class="area-modal__input"
                      type="number"
                      formControlName="external_doors" />
                  </div>
                  <div class="area-modal__field">
                    <label class="area-modal__label">{{ 'room.windows' | translate }}</label>
                    <input class="area-modal__input"
                      type="number"
                      formControlName="windows" />
                  </div>
                </div>
              </div>
            }

            <div class="area-modal__actions">
              @if (hasEdit()) {
                <button class="area-modal__button area-modal__button--secondary"
                  type="button"
                  (click)="onEdit()">
                  {{ 'general.edit' | translate }}
                </button>
              }
              @if (isRoot()) {
                <button class="area-modal__button area-modal__button--danger"
                  type="button"
                  (click)="deleteSelf()">
                  {{ 'general.delete' | translate }}
                </button>
              }
            </div>
          </form>
        </div>
      }

      @case ('room') {
        <app-room [roomType]="type()"
          (room)="onAreaRoom($event)"></app-room>
      }

      @case ('common') {
        <app-room [roomType]="type()"
          (room)="onAreaRoom($event)"
          (cancelled)="onCancel()"></app-room>
      }
    }
  </section>

  <div modalFooter
    class="area-modal__footer-actions">
    <button class="area-modal__button area-modal__button--secondary"
      type="button"
      (click)="dismiss()">
      {{ 'general.cancel' | translate }}
    </button>

    @if (type() === 'area') {
      <button class="area-modal__button area-modal__button--primary"
        type="button"
        [disabled]="!formGroup.valid"
        (click)="save()">
        {{ 'general.save' | translate }}
      </button>
    } @else if (type() == null && rooms != null) {
      <button class="area-modal__button area-modal__button--primary"
        type="button"
        [disabled]="!roomFormGroup.valid"
        (click)="saveRooms()">
        {{ 'general.save' | translate }}
      </button>
    }
  </div>
</app-modal-shell>
